<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Chatbot</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">The Discovery chatbot is a channel through which the user can obtain information of interest about startups. The advantage of using the chatbot is the possibility to use natural language to engage in even complex conversations.
The Chatbot can be used following a guided conversation using the buttons or in a free text or with a hybrid approach.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to switch language</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">The Chatbot is available in Italian and English. If you want to change the language you can click on the "Language and other settings" chip at the top and change it in the drop-down menu.
                    <br>
                        <v-img
                                max-width="300"
                                :src="require('@/assets/img/help/languageChip.png')"
                        >
                </v-img>
</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">Plain search</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">Through the chatbot it is possible to obtain 2 types of information:
                        <ul>
                            <li>search for a list of startups based on certain filters</li>
                            <li>get information of a specific startup based on the name</li>
                        </ul>
For the first case it is possible to filter the search according to the following fields: addressed market, technology area, vertical, idea state, patent, region/city, country.
Remember that subsequent searches are refinements of previous ones and consequently you have to reset the conversation if you want to return to the initial state.

Instead, you can ask information of a specific startup for example typing:
“Can you talk me about Cogisen?”
“What is Apio market?”
Or simply “Tolemaica”

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">Explanation of button-based filters</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To do a search using the buttons, simply click on them during the guided conversation. In the first step, you can click on the name of the field you wish to filter on (e.g. Addressed market).
                        <br>
                        <v-img
                                max-width="400"
                                :src="require('@/assets/img/help/chatFirstStep.png')"
                        >
                </v-img>
At this point, the chatbot suggests possible values for that field (e.g. Energy, Healthy, Insurance). By clicking on one of these (e.g. Energy) you will get all the startups working in the Energy market.
You will be able to continue the search with subsequent refinements or simply view the results reported in the chat or in more detail by clicking on the green tick at the top.
                        <br>
                        <v-img
                                max-width="300"
                                :src="require('@/assets/img/help/greenTick.png')"
                        >
                </v-img>

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to use the text box</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">The same searches can be performed without using the buttons, but with the text bar.
Here you can still follow the guided flow, by writing the filter to be applied, or by doing free searches.
This means that you can ask the chatbot:
"Can you give me the Italian startups?"

But it is also possible to combine several filters at the same time, for example:
"Can you find me startups with patent in the energy market"?

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">Expert users: how to switch off button-based filters</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">If a user considers himself an expert in the platform and does not need to be guided, he can at any time decide to disable the filters by means of buttons.

To do so, click on the "Language and other settings" chip at the top and enable or disable the buttons.
                       <br>
                        <v-img
                                max-width="400"
                                :src="require('@/assets/img/help/enableButtons.png')"
                        >
                </v-img>

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">Advanced search: What is it?</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">The advanced search is a type of search in addition to the filter-based search.
It makes it possible to retrieve startups not according to the value of a particular field, but according to a transversal criterion. The search verifies the exact match of the words in the query with at least one word in "English idea description", "Italian idea description" and "tags".

If the query consists of more than one word, the search is carried out in or, so all startups that have a match with at least one of the words in the query are returned.

In addition, the functionality is enhanced by the use of synonyms (managed by the admins), which improves the effectiveness of the search.

Thanks to the algorithm used, each startup retrieved obtains a relevance score, based on the occurrences of the words in the query. The search output returns the startups in order of relevance.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">Advanced search: How to use it</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To use the advanced chatbot search you can:
                        <ul>
                            <li>click on the red button shown in the first welcome message</li>
                            <li>activate the conversational flow by writing in the text box a request such as 'I want to do an advanced search’</li>
                        </ul>
Now you can type your query. The resulting startups are returned in order of relevance in chat. You can view more details by pressing the green tick button.
                        <br>
                        <v-img
                                max-width="600"
                                :src="require('@/assets/img/help/advancedSearch.png')"
                        >
                </v-img>

</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "ChatbotHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>